import { render, staticRenderFns } from "./LojasPedidoDialogAprovar.vue?vue&type=template&id=7992f7f9&"
import script from "./LojasPedidoDialogAprovar.vue?vue&type=script&lang=ts&"
export * from "./LojasPedidoDialogAprovar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports